import { styled } from '../../../../../utils/styled';
import { propStyles } from '../../../../../utils/propStyles';

const StyledComponent = styled<any, any>('span', 'toastText', 'feedback-toast')`
    ${propStyles};
`;

StyledComponent.defaultProps = {
    fontWeight: 'bold',
};

export default StyledComponent;



// WEBPACK FOOTER //
// ./src/Components/Feedback/Components/Toast/StyledComponents/ToastText.tsx